import React from 'react';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import MuiLink from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';
import {
  getAuditFromCellModel,
  getAuditToCellModel,
  getAuditClientLabel,
  getAuditClientId,
  getAuditOrderShortId,
  getAuditOrderId,
} from '../utils/auditLogDisplay';

export function AuditLogFromCell({ log, getAuditStatusLabel }) {
  const m = getAuditFromCellModel(log);
  if (m.type === 'empty') return '—';
  if (m.type === 'text') {
    return (
      <Typography variant="body2" sx={{ maxWidth: 280, whiteSpace: 'normal' }}>
        {m.text}
      </Typography>
    );
  }
  return <Chip label={getAuditStatusLabel(m.status)} size="small" variant="outlined" />;
}

export function AuditLogToCell({ log, getAuditStatusLabel, getToChipColor }) {
  const m = getAuditToCellModel(log);
  if (m.type === 'empty') return '—';
  if (m.type === 'text') {
    return (
      <Typography variant="body2" sx={{ maxWidth: 280, whiteSpace: 'normal' }}>
        {m.text}
      </Typography>
    );
  }
  const color = getToChipColor ? getToChipColor(m.status) : 'default';
  return <Chip label={getAuditStatusLabel(m.status)} size="small" color={color || 'default'} />;
}

export function AuditLogClientLinkCell({ log }) {
  const id = getAuditClientId(log);
  const label = getAuditClientLabel(log);
  if (!id || !label) return '—';
  return (
    <MuiLink component={RouterLink} to={`/clients/${id}`} underline="hover" variant="body2">
      {label}
    </MuiLink>
  );
}

export function AuditLogOrderLinkCell({ log }) {
  const id = getAuditOrderId(log);
  const short = getAuditOrderShortId(log);
  if (!id || !short) return '—';
  return (
    <MuiLink component={RouterLink} to={`/orders/${id}`} underline="hover" variant="body2">
      {short}
    </MuiLink>
  );
}
